export const GET_ALLOWED_DOMAINS_RESTRICTIONS = "GET_ALLOWED_DOMAINS_RESTRICTIONS";
export const GET_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS = "GET_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS";
export const GET_ALLOWED_DOMAINS_RESTRICTIONS_FAIL = "GET_ALLOWED_DOMAINS_RESTRICTIONS_FAIL";
export const DELETE_ALLOWED_DOMAINS_RESTRICTIONS = "DELETE_ALLOWED_DOMAINS_RESTRICTIONS";
export const DELETE_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS = "DELETE_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS";
export const DELETE_ALLOWED_DOMAINS_RESTRICTIONS_FAIL = "DELETE_ALLOWED_DOMAINS_RESTRICTIONS_FAIL";
export const POST_ALLOWED_DOMAINS_RESTRICTIONS = "POST_ALLOWED_DOMAINS_RESTRICTIONS";
export const POST_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS = "POST_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS";
export const POST_ALLOWED_DOMAINS_RESTRICTIONS_FAIL = "POST_ALLOWED_DOMAINS_RESTRICTIONS_FAIL";
export const GET_SSO_ONLY_LOGIN = "GET_SSO_ONLY_LOGIN";
export const GET_SSO_ONLY_LOGIN_SUCCESS = "GET_SSO_ONLY_LOGIN_SUCCESS";
export const GET_SSO_ONLY_LOGIN_FAIL = "GET_SSO_ONLY_LOGIN_FAIL";
export const TOGGLE_SSO_ONLY_LOGIN = "TOGGLE_SSO_ONLY_LOGIN";
export const TOGGLE_SSO_ONLY_LOGIN_SUCCESS = "TOGGLE_SSO_ONLY_LOGIN_SUCCESS";
export const TOGGLE_SSO_ONLY_LOGIN_FAIL = "TOGGLE_SSO_ONLY_LOGIN_FAIL";

export const UPDATE_TWO_FACTOR_ORG_ENABLED = "UPDATE_TWO_FACTOR_ENABLED";

export const UPDATE_TWO_FACTOR_ORG_ENABLED_SUCCESS = "UPDATE_TWO_FACTOR_ENABLED_SUCCESS";
export const UPDATE_TWO_FACTOR_ORG_ENABLED_FAIL = "UPDATE_TWO_FACTOR_ENABLED_FAIL";

export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";

export const GET_DELETED_USERS = "GET_DELETED_USERS";
export const GET_DELETED_USERS_SUCCESS = "GET_DELETED_USERS_SUCCESS";
export const GET_DELETED_USERS_FAIL = "GET_DELETED_USERS_FAIL";

export const GET_ORGANIZATION_DETAILS = "GET_ORGANIZATION_DETAILS";
export const GET_ORGANIZATION_DETAILS_SUCCESS = "GET_ORGANIZATION_DETAILS_SUCCESS";
export const GET_ORGANIZATION_DETAILS_FAIL = "GET_ORGANIZATION_DETAILS_FAIL";
export const GET_SUBSCRIPTION_DETAILS = "GET_SUBSCRIPTION_DETAILS";
export const GET_SUBSCRIPTION_DETAILS_SUCCESS = "GET_SUBSCRIPTION_DETAILS_SUCCESS";
export const GET_SUBSCRIPTION_DETAILS_FAIL = "GET_SUBSCRIPTION_DETAILS_FAIL";
export const INVITE_USER = "INVITE_USER";
export const INVITE_USER_SUCCESS = "INVITE_USER_SUCCESS";
export const INVITE_USER_FAIL = "INVITE_USER_FAIL";
export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL"
export const UPDATE_BILLING_DETAILS = "UPDATE_BILLING_DETAILS";
export const UPDATE_BILLING_DETAILS_SUCCESS = "UPDATE_BILLING_DETAILS_SUCCESS";
export const UPDATE_BILLING_DETAILS_FAIL = "UPDATE_BILLING_DETAILS_FAIL";
export const GET_ROLES = "GET_ROLES";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_FAIL = "GET_ROLES_FAIL";
export const UPDATE_ROLES = "UPDATE_ROLES";
export const UPDATE_ROLES_SUCCESS = "UPDATE_ROLES_SUCCESS";
export const UPDATE_ROLES_FAIL = "UPDATE_ROLES_FAIL";
export const CREATE_BLUEJAY_TEAM = "CREATE_BLUEJAY_TEAM";
export const CREATE_BLUEJAY_TEAM_SUCCESS = "CREATE_BLUEJAY_TEAM_SUCCESS";
export const CREATE_BLUEJAY_TEAM_FAIL = "CREATE_BLUEJAY_TEAM_FAIL";
export const GET_BLUEJAY_TEAM = "GET_BLUEJAY_TEAM";
export const GET_BLUEJAY_TEAM_SUCCESS = "GET_BLUEJAY_TEAM_SUCCESS";
export const GET_BLUEJAY_TEAM_FAIL = "GET_BLUEJAY_TEAM_FAIL";
export const DELETE_BLUEJAY_TEAM = "DELETE_BLUEJAY_TEAM";
export const DELETE_BLUEJAY_TEAM_SUCCESS = "DELETE_BLUEJAY_TEAM_SUCCESS";
export const DELETE_BLUEJAY_TEAM_FAIL = "DELETE_BLUEJAY_TEAM_FAIL";
export const UPDATE_BLUEJAY_TEAM = "UPDATE_BLUEJAY_TEAM";
export const UPDATE_BLUEJAY_TEAM_SUCCESS = "UPDATE_BLUEJAY_TEAM_SUCCESS";
export const UPDATE_BLUEJAY_TEAM_FAIL = "UPDATE_BLUEJAY_TEAM_FAIL";
export const DELETE_SERVICE_FROM_TEAM = "DELETE_SERVICE_FROM_TEAM";
export const DELETE_SERVICE_FROM_TEAM_SUCCESS = "DELETE_SERVICE_FROM_TEAM_SUCCESS";
export const DELETE_SERVICE_FROM_TEAM_FAIL = "DELETE_SERVICE_FROM_TEAM_FAIL";
export const GET_UNMAPPED_TEAM_SERVICES = "GET_UNMAPPED_TEAM_SERVICES";
export const GET_UNMAPPED_TEAM_SERVICES_SUCCESS = "GET_UNMAPPED_TEAM_SERVICES_SUCCESS";
export const GET_UNMAPPED_TEAM_SERVICES_FAIL = "GET_UNMAPPED_TEAM_SERVICES_FAIL";
export const MAP_SERVICES_TO_TEAM = "MAP_SERVICES_TO_TEAM";
export const MAP_SERVICES_TO_TEAM_SUCCESS = "MAP_SERVICES_TO_TEAM_SUCCESS";
export const MAP_SERVICES_TO_TEAM_FAIL = "MAP_SERVICES_TO_TEAM_FAIL";
export const NON_TEAM_USERS = "NON_TEAM_USERS";
export const NON_TEAM_USERS_SUCCESS = "NON_TEAM_USERS_SUCCESS";
export const NON_TEAM_USERS_FAIL = "NON_TEAM_USERS_FAIL";
export const ADD_USERS_TO_TEAM = "ADD_USERS_TO_TEAM";
export const ADD_USERS_TO_TEAM_SUCCESS = "ADD_USERS_TO_TEAM_SUCCESS";
export const ADD_USERS_TO_TEAM_FAIL = "ADD_USERS_TO_TEAM_FAIL";
export const REMOVE_USER_FROM_TEAM = "REMOVE_USER_FROM_TEAM";
export const REMOVE_USER_FROM_TEAM_SUCCESS = "REMOVE_USER_FROM_TEAM_SUCCESS";
export const REMOVE_USER_FROM_TEAM_FAIL = "REMOVE_USER_FROM_TEAM_FAIL";
export const GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS = "GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS";
export const GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS = "GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS";
export const GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL = "GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL";
export const UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS = "UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS";
export const UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS = "UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS";
export const UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL = "UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL";

export const GET_ORG_AWS_SERVICE_LIST = "GET_ORG_AWS_SERVICE_LIST";
export const GET_ORG_AWS_SERVICE_LIST_SUCCESS = "GET_ORG_AWS_SERVICE_LIST_SUCCESS";
export const GET_ORG_AWS_SERVICE_LIST_FAIL = "GET_ORG_AWS_SERVICE_LIST_FAIL";

export const UPDATE_STATUS_ORG_AWS_SERVICE = 'UPDATE_STATUS_ORG_AWS_SERVICE';

export const UPDATE_STATUS_ORG_AWS_SERVICE_SUCCESS = "UPDATE_STATUS_ORG_AWS_SERVICE_SUCCESS";

export const UPDATE_STATUS_ORG_AWS_SERVICE_FAIL = "UPDATE_STATUS_ORG_AWS_SERVICE_FAIL";

export const GET_ALERT_DEPLOYMENT_COUNT = "GET_ALERT_DEPLOYMENT_COUNT";
export const GET_ALERT_DEPLOYMENT_COUNT_SUCCESS = "GET_ALERT_DEPLOYMENT_COUNT_SUCCESS";
export const GET_ALERT_DEPLOYMENT_COUNT_FAIL = "GET_ALERT_DEPLOYMENT_COUNT_FAIL";

export const GET_RESOURCE_SCAN_COUNT = "GET_RESOURCE_SCAN_COUNT"; 
export const GET_RESOURCE_SCAN_COUNT_SUCCESS = "GET_RESOURCE_SCAN_COUNT_SUCCESS";
export const GET_RESOURCE_SCAN_COUNT_FAIL = "GET_RESOURCE_SCAN_COUNT_FAIL";

export const GET_DAILY_RESOURCE_COUNT = "GET_DAILY_RESOURCE_COUNT";
export const GET_DAILY_RESOURCE_COUNT_SUCCESS = "GET_DAILY_RESOURCE_COUNT_SUCCESS";
export const GET_DAILY_RESOURCE_COUNT_FAIL = "GET_DAILY_RESOURCE_COUNT_FAIL";

export const GET_MONTHLY_RESOURCE_COUNT = "GET_MONTHLY_RESOURCE_COUNT";
export const GET_MONTHLY_RESOURCE_COUNT_SUCCESS = "GET_MONTHLY_RESOURCE_COUNT_SUCCESS";
export const GET_MONTHLY_RESOURCE_COUNT_FAIL = "GET_MONTHLY_RESOURCE_COUNT_FAIL";

export const GET_RESOURCE_MAPPING_CONFIG = "GET_RESOURCE_MAPPING_CONFIG";
export const GET_RESOURCE_MAPPING_CONFIG_FAIL =" GET_RESOURCE_MAPPING_CONFIG_FAIL";
export const GET_RESOURCE_MAPPING_CONFIG_SUCCESS = "GET_RESOURCE_MAPPING_CONFIG_SUCCESS";

export const POST_RESOURCE_MAPPING_CONFIG = "POST_RESOURCE_MAPPING_CONFIG";
export const POST_RESOURCE_MAPPING_CONFIG_FAIL = "POST_RESOURCE_MAPPING_CONFIG_FAIL";
export const POST_RESOURCE_MAPPING_CONFIG_SUCCESS = "POST_RESOURCE_MAPPING_CONFIG_SUCCESS";

export const DELETE_RESOURCE_MAPPING_CONFIG = "DELETE_RESOURCE_MAPPING_CONFIG";
export const DELETE_RESOURCE_MAPPING_CONFIG_FAIL = "DELETE_RESOURCE_MAPPING_CONFIG_FAIL";
export const DELETE_RESOURCE_MAPPING_CONFIG_SUCCESS = "DELETE_RESOURCE_MAPPING_CONFIG_SUCCESS";

export const UPDATE_RESOURCE_MAPPING_CONFIG = "UPDATE_RESOURCE_MAPPING_CONFIG";
export const UPDATE_RESOURCE_MAPPING_CONFIG_FAIL = "UPDATE_RESOURCE_MAPPING_CONFIG_FAIL";
export const UPDATE_RESOURCE_MAPPING_CONFIG_SUCCESS = "UPDATE_RESOURCE_MAPPING_CONFIG_SUCCESS";

export const GET_PAGINATED_USERS = "GET_PAGINATED_USERS";
export const GET_PAGINATED_USERS_SUCCESS = "GET_PAGINATED_USERS_SUCCESS";
export const GET_PAGINATED_USERS_FAIL = "GET_PAGINATED_USERS_FAIL";

export const GET_USERS_COUNT = "GET_USERS_COUNT";
export const GET_USERS_COUNT_SUCCESS = "GET_USERS_COUNT_SUCCESS";
export const GET_USERS_COUNT_FAIL = "GET_USERS_COUNT_FAIL";

export const GET_SUGGESTED_MAPPINGS = "GET_SUGGESTED_MAPPINGS";
export const GET_SUGGESTED_MAPPINGS_SUCCESS = "GET_SUGGESTED_MAPPINGS_SUCCESS";
export const GET_SUGGESTED_MAPPINGS_FAIL = "GET_SUGGESTED_MAPPINGS_FAIL";

export const POST_UPDATE_SUGGESTED_MAPPINGS = "POST_UPDATE_SUGGESTED_MAPPINGS";
export const POST_UPDATE_SUGGESTED_MAPPINGS_SUCCESS = "POST_UPDATE_SUGGESTED_MAPPINGS_SUCCESS";
export const POST_UPDATE_SUGGESTED_MAPPINGS_FAIL = "POST_UPDATE_SUGGESTED_MAPPINGS_FAIL";

export const TOGGLE_PUBLISH_STATUS_PAGE = "TOGGLE_PUBLISH_STATUS_PAGE";
export const TOGGLE_PUBLISH_STATUS_PAGE_SUCCESS = "TOGGLE_PUBLISH_STATUS_PAGE_SUCCESS";
export const TOGGLE_PUBLISH_STATUS_PAGE_FAIL = "TOGGLE_PUBLISH_STATUS_PAGE_FAIL";

export const SET_ORG_MAINTENANCE_WINDOW = "SET_ORG_MAINTENANCE_WINDOW";
export const SET_ORG_MAINTENANCE_WINDOW_SUCCESS = "SET_ORG_MAINTENANCE_WINDOW_SUCCESS";
export const SET_ORG_MAINTENANCE_WINDOW_FAIL = "SET_ORG_MAINTENANCE_WINDOW_FAIL";

export const POST_EXTERNAL_PAGES_DETAILS = "POST_EXTERNAL_PAGES_DETAILS";
export const POST_EXTERNAL_PAGES_DETAILS_SUCCESS = "POST_EXTERNAL_PAGES_DETAILS_SUCCESS";
export const POST_EXTERNAL_PAGES_DETAILS_FAIL = "POST_EXTERNAL_PAGES_DETAILS_FAIL";

export const CREATE_CHANGE_EVENT_WEBHOOK = "CREATE_CHANGE_EVENT_WEBHOOK";
export const CREATE_CHANGE_EVENT_WEBHOOK_SUCCESS = "CREATE_CHANGE_EVENT_WEBHOOK_SUCCESS";
export const CREATE_CHANGE_EVENT_WEBHOOK_FAIL = "CREATE_CHANGE_EVENT_WEBHOOK_FAIL";
export const RESET_CREATE_EVENT_WEBHOOK = "RESET_CREATE_EVENT_WEBHOOK";

export const GET_CHANGE_EVENT_WEBHOOKS = 'GET_CHANGE_EVENT_WEBHOOKS';
export const GET_CHANGE_EVENT_WEBHOOKS_SUCCESS = 'GET_CHANGE_EVENT_WEBHOOKS_SUCCESS';
export const GET_CHANGE_EVENT_WEBHOOKS_FAIL = 'GET_CHANGE_EVENT_WEBHOOKS_FAIL';

export const GET_CHANGE_EVENTS = 'GET_CHANGE_EVENTS';
export const GET_CHANGE_EVENTS_SUCCESS = 'GET_CHANGE_EVENTS_SUCCESS';
export const GET_CHANGE_EVENTS_FAIL = 'GET_CHANGE_EVENTS_FAIL';

export const GET_CHANGE_EVENT_BY_ID = 'GET_CHANGE_EVENT_BY_ID';
export const GET_CHANGE_EVENT_BY_ID_SUCCESS = 'GET_CHANGE_EVENT_BY_ID_SUCCESS';
export const GET_CHANGE_EVENT_BY_ID_FAIL = 'GET_CHANGE_EVENT_BY_ID_FAIL';

export const CREATE_OKTA_SSO_INTEGRATION = 'CREATE_OKTA_SSO_INTEGRATION';
export const CREATE_OKTA_SSO_INTEGRATION_SUCCESS = 'CREATE_OKTA_SSO_INTEGRATION_SUCCESS';
export const CREATE_OKTA_SSO_INTEGRATION_FAIL = 'CREATE_OKTA_SSO_INTEGRATION_FAIL';

export const GET_OKTA_SSO_INTEGRATION = 'GET_OKTA_SSO_INTEGRATION';
export const GET_OKTA_SSO_INTEGRATION_SUCCESS = 'GET_OKTA_SSO_INTEGRATION_SUCCESS';
export const GET_OKTA_SSO_INTEGRATION_FAIL = 'GET_OKTA_SSO_INTEGRATION_FAIL';

export const APPLY_MAPPING_CONFIG = 'APPLY_MAPPING_CONFIG';
export const APPLY_MAPPING_CONFIG_SUCCESS = 'APPLY_MAPPING_CONFIG_SUCCESS';
export const APPLY_MAPPING_CONFIG_FAIL = 'APPLY_MAPPING_CONFIG_FAIL';

export const GET_RECENT_CHANGE_EVENTS = 'GET_RECENT_CHANGE_EVENTS';
export const GET_RECENT_CHANGE_EVENTS_SUCCESS = 'GET_RECENT_CHANGE_EVENTS_SUCCESS';
export const GET_RECENT_CHANGE_EVENTS_FAIL = 'GET_RECENT_CHANGE_EVENTS_FAIL';

